export function publicOrigin(value) {
    try {
        const url = new URL(value);
        if (url.username || url.password || url.search || url.hash || url.pathname !== '/') return null;
        if (url.protocol !== 'https:' && !(url.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname))) return null;
        return url.origin;
    } catch { return null; }
}

export function translationConfig(appUrl, apiUrl) {
    return { appOrigin: publicOrigin(appUrl), apiOrigin: publicOrigin(apiUrl) };
}

export function teacherTranslationUrl(appOrigin, classId) {
    if (!appOrigin || !/^[A-Za-z0-9_-]{1,64}$/.test(String(classId ?? ''))) return null;
    return `${appOrigin}/translate?classId=${encodeURIComponent(classId)}`;
}

export function studentCaptionUrl(appOrigin, state) {
    if (!appOrigin || state.status !== 'active'
        || !/^\/translate\/join\/[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(state.guestPath || '')) return null;
    return appOrigin + state.guestPath;
}

// Each view owns one poller. Stop aborts requests and ignores late results.
export function createClassLivePoller({ load, onState, intervalMs = 15000,
    setTimer = setTimeout, clearTimer = clearTimeout, now = Date.now }) {
    let generation = 0;
    let timer;
    let controller;
    let latest;
    function stop() {
        generation++;
        clearTimer(timer);
        controller?.abort();
        latest = undefined;
    }
    function start(classId) {
        stop();
        const run = generation;
        onState({ status: 'loading' });
        async function poll() {
            if (run !== generation) return;
            if (latest?.status === 'active' && Date.parse(latest.expiresAt) <= now()) {
                latest = { status: 'waiting' };
                onState(latest);
            }
            controller = new AbortController();
            try {
                const result = await load(classId, controller.signal);
                if (run !== generation) return;
                if (result.status !== 'waiting' && result.status !== 'active') throw new Error('Invalid caption status');
                if (result.status === 'active' && (!Number.isFinite(Date.parse(result.expiresAt))
                    || !studentCaptionUrl('https://example.invalid', result))) throw new Error('Invalid caption link');
                latest = result.status === 'active' && Date.parse(result.expiresAt) <= now() ? { status: 'waiting' } : result;
                onState(latest);
            } catch (error) {
                if (run !== generation) return;
                latest = { status: 'error' };
                onState(latest);
            }
            if (run !== generation) return;
            const delay = latest.status === 'active' ? Math.min(intervalMs, Math.max(1, Date.parse(latest.expiresAt) - now())) : intervalMs;
            timer = setTimer(poll, delay);
        }
        void poll();
    }
    return { start, stop };
}
